/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeJobSource
 */
export interface TapeJobSource {
    /**
     * 
     * @type {string}
     * @memberof TapeJobSource
     */
    path: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TapeJobSource
     */
    options?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof TapeJobSource
     */
    include?: string | null;
}

export function TapeJobSourceFromJSON(json: any): TapeJobSource {
    return TapeJobSourceFromJSONTyped(json, false);
}

export function TapeJobSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeJobSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'include': !exists(json, 'include') ? undefined : json['include'],
    };
}

export function TapeJobSourceToJSON(value?: TapeJobSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'options': value.options,
        'include': value.include,
    };
}


